"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SV = void 0;
exports.SV = {
    numericCode: '222',
    alpha2Code: 'SV',
    alpha3Code: 'SLV',
    englishName: {
        short: 'El Salvador',
        full: 'the Republic of El Salvador',
    },
    names: {
        full: {
            en: 'the Republic of El Salvador',
            fr: "la République d'El Salvador",
            es: 'El Salvador',
        },
        short: {
            en: 'El Salvador',
            fr: 'El Salvador',
            es: 'El Salvador',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'es',
            languageAlpha3Code: 'spa',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'SV-AH': {
            numericCode: '222',
            code: 'SV-AH',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Ahuachapán',
            },
        },
        'SV-CA': {
            numericCode: '222',
            code: 'SV-CA',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Cabañas',
            },
        },
        'SV-CH': {
            numericCode: '222',
            code: 'SV-CH',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Chalatenango',
            },
        },
        'SV-CU': {
            numericCode: '222',
            code: 'SV-CU',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Cuscatlán',
            },
        },
        'SV-LI': {
            numericCode: '222',
            code: 'SV-LI',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'La Libertad',
            },
        },
        'SV-MO': {
            numericCode: '222',
            code: 'SV-MO',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Morazán',
            },
        },
        'SV-PA': {
            numericCode: '222',
            code: 'SV-PA',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'La Paz',
            },
        },
        'SV-SA': {
            numericCode: '222',
            code: 'SV-SA',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Santa Ana',
            },
        },
        'SV-SM': {
            numericCode: '222',
            code: 'SV-SM',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'San Miguel',
            },
        },
        'SV-SO': {
            numericCode: '222',
            code: 'SV-SO',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Sonsonate',
            },
        },
        'SV-SS': {
            numericCode: '222',
            code: 'SV-SS',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'San Salvador',
            },
        },
        'SV-SV': {
            numericCode: '222',
            code: 'SV-SV',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'San Vicente',
            },
        },
        'SV-UN': {
            numericCode: '222',
            code: 'SV-UN',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'La Unión',
            },
        },
        'SV-US': {
            numericCode: '222',
            code: 'SV-US',
            category: {
                id: '379',
                names: {
                    en: {
                        singular: 'department',
                        plural: 'departments',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    es: {
                        singular: 'departamento',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                es: 'Usulután',
            },
        },
    },
    cities: [
        {
            name: 'Zacatecoluca',
            subdivision: 'La Paz',
        },
        {
            name: 'Usulután',
            subdivision: 'Usulután',
        },
        {
            name: 'Soyapango',
            subdivision: 'San Salvador',
        },
        {
            name: 'Sonzacate',
            subdivision: 'Sonsonate',
        },
        {
            name: 'Sonsonate',
            subdivision: 'Sonsonate',
        },
        {
            name: 'Sensuntepeque',
            subdivision: 'Cabañas',
        },
        {
            name: 'San Vicente',
            subdivision: 'San Vicente',
        },
        {
            name: 'Santiago de María',
            subdivision: 'Usulután',
        },
        {
            name: 'Santa Ana',
            subdivision: 'Santa Ana',
        },
        {
            name: 'San Salvador',
            subdivision: 'San Salvador',
        },
        {
            name: 'San Rafael Oriente',
            subdivision: 'San Miguel',
        },
        {
            name: 'San Miguel',
            subdivision: 'San Miguel',
        },
        {
            name: 'San Martín',
            subdivision: 'Cuscatlán',
        },
        {
            name: 'San Marcos',
            subdivision: 'San Salvador',
        },
        {
            name: 'San Francisco',
            subdivision: 'Morazán',
        },
        {
            name: 'Quezaltepeque',
            subdivision: 'La Libertad',
        },
        {
            name: 'Puerto El Triunfo',
            subdivision: 'Usulután',
        },
        {
            name: 'Santa Tecla',
            subdivision: 'La Libertad',
        },
        {
            name: 'Metapán',
            subdivision: 'Santa Ana',
        },
        {
            name: 'Mejicanos',
            subdivision: 'San Salvador',
        },
        {
            name: 'La Unión',
            subdivision: 'La Unión',
        },
        {
            name: 'La Libertad',
            subdivision: 'La Libertad',
        },
        {
            name: 'Izalco',
            subdivision: 'Sonsonate',
        },
        {
            name: 'Ilopango',
            subdivision: 'San Salvador',
        },
        {
            name: 'Delgado',
            subdivision: 'San Salvador',
        },
        {
            name: 'Cuscatancingo',
            subdivision: 'San Salvador',
        },
        {
            name: 'Cojutepeque',
            subdivision: 'Cuscatlán',
        },
        {
            name: 'Chalchuapa',
            subdivision: 'Santa Ana',
        },
        {
            name: 'Chalatenango',
            subdivision: 'Chalatenango',
        },
        {
            name: 'Ayutuxtepeque',
            subdivision: 'San Salvador',
        },
        {
            name: 'Apopa',
            subdivision: 'San Salvador',
        },
        {
            name: 'Antiguo Cuscatlán',
            subdivision: 'La Libertad',
        },
        {
            name: 'Ahuachapán',
            subdivision: 'Ahuachapán',
        },
        {
            name: 'Aguilares',
            subdivision: 'San Salvador',
        },
        {
            name: 'Acajutla',
            subdivision: 'Sonsonate',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU1YuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvU1YudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSxhQUFhO1FBQ3BCLElBQUksRUFBRSw2QkFBNkI7S0FDdEM7SUFDRCxLQUFLLEVBQUU7UUFDSCxJQUFJLEVBQUU7WUFDRixFQUFFLEVBQUUsNkJBQTZCO1lBQ2pDLEVBQUUsRUFBRSw2QkFBNkI7WUFDakMsRUFBRSxFQUFFLGFBQWE7U0FDcEI7UUFDRCxLQUFLLEVBQUU7WUFDSCxFQUFFLEVBQUUsYUFBYTtZQUNqQixFQUFFLEVBQUUsYUFBYTtZQUNqQixFQUFFLEVBQUUsYUFBYTtTQUNwQjtLQUNKO0lBQ0QsU0FBUyxFQUFFO1FBQ1A7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsS0FBSztTQUMxQjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7UUFDRDtZQUNJLGtCQUFrQixFQUFFLElBQUk7WUFDeEIsa0JBQWtCLEVBQUUsS0FBSztZQUN6QixnQkFBZ0IsRUFBRSxJQUFJO1NBQ3pCO0tBQ0o7SUFDRCxZQUFZLEVBQUU7UUFDVixPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsYUFBYTtxQkFDeEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxhQUFhO3dCQUN2QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsWUFBWTthQUNuQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLGFBQWE7cUJBQ3hCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsYUFBYTt3QkFDdkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFlBQVk7d0JBQ3RCLE1BQU0sRUFBRSxhQUFhO3FCQUN4QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGFBQWE7d0JBQ3ZCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxjQUFjO2FBQ3JCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsYUFBYTtxQkFDeEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxhQUFhO3dCQUN2QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLGFBQWE7cUJBQ3hCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsYUFBYTt3QkFDdkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFlBQVk7d0JBQ3RCLE1BQU0sRUFBRSxhQUFhO3FCQUN4QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGFBQWE7d0JBQ3ZCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsYUFBYTtxQkFDeEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxhQUFhO3dCQUN2QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsYUFBYTtxQkFDeEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxhQUFhO3dCQUN2QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLGFBQWE7cUJBQ3hCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsYUFBYTt3QkFDdkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFlBQVk7d0JBQ3RCLE1BQU0sRUFBRSxhQUFhO3FCQUN4QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGFBQWE7d0JBQ3ZCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsYUFBYTtxQkFDeEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxhQUFhO3dCQUN2QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLGFBQWE7cUJBQ3hCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsYUFBYTt3QkFDdkIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFlBQVk7d0JBQ3RCLE1BQU0sRUFBRSxhQUFhO3FCQUN4QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGFBQWE7d0JBQ3ZCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsYUFBYTtxQkFDeEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxhQUFhO3dCQUN2QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO0tBQ0o7SUFDRCxNQUFNLEVBQUU7UUFDSjtZQUNJLElBQUksRUFBRSxjQUFjO1lBQ3BCLFdBQVcsRUFBRSxRQUFRO1NBQ3hCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsVUFBVTtTQUMxQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFdBQVc7WUFDakIsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxXQUFXO1NBQzNCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsV0FBVztTQUMzQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLFNBQVM7U0FDekI7UUFDRDtZQUNJLElBQUksRUFBRSxhQUFhO1lBQ25CLFdBQVcsRUFBRSxhQUFhO1NBQzdCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFdBQVcsRUFBRSxVQUFVO1NBQzFCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsV0FBVztTQUMzQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGNBQWM7WUFDcEIsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxvQkFBb0I7WUFDMUIsV0FBVyxFQUFFLFlBQVk7U0FDNUI7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxZQUFZO1NBQzVCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsWUFBWTtZQUNsQixXQUFXLEVBQUUsV0FBVztTQUMzQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFlBQVk7WUFDbEIsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxlQUFlO1lBQ3JCLFdBQVcsRUFBRSxTQUFTO1NBQ3pCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsZUFBZTtZQUNyQixXQUFXLEVBQUUsYUFBYTtTQUM3QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixXQUFXLEVBQUUsVUFBVTtTQUMxQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxTQUFTO1lBQ2YsV0FBVyxFQUFFLFdBQVc7U0FDM0I7UUFDRDtZQUNJLElBQUksRUFBRSxXQUFXO1lBQ2pCLFdBQVcsRUFBRSxjQUFjO1NBQzlCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsVUFBVTtZQUNoQixXQUFXLEVBQUUsVUFBVTtTQUMxQjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxRQUFRO1lBQ2QsV0FBVyxFQUFFLFdBQVc7U0FDM0I7UUFDRDtZQUNJLElBQUksRUFBRSxVQUFVO1lBQ2hCLFdBQVcsRUFBRSxjQUFjO1NBQzlCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxjQUFjO1NBQzlCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsZUFBZTtZQUNyQixXQUFXLEVBQUUsY0FBYztTQUM5QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGFBQWE7WUFDbkIsV0FBVyxFQUFFLFdBQVc7U0FDM0I7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxXQUFXO1NBQzNCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsY0FBYztZQUNwQixXQUFXLEVBQUUsY0FBYztTQUM5QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLGVBQWU7WUFDckIsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxPQUFPO1lBQ2IsV0FBVyxFQUFFLGNBQWM7U0FDOUI7UUFDRDtZQUNJLElBQUksRUFBRSxtQkFBbUI7WUFDekIsV0FBVyxFQUFFLGFBQWE7U0FDN0I7UUFDRDtZQUNJLElBQUksRUFBRSxZQUFZO1lBQ2xCLFdBQVcsRUFBRSxZQUFZO1NBQzVCO1FBQ0Q7WUFDSSxJQUFJLEVBQUUsV0FBVztZQUNqQixXQUFXLEVBQUUsY0FBYztTQUM5QjtRQUNEO1lBQ0ksSUFBSSxFQUFFLFVBQVU7WUFDaEIsV0FBVyxFQUFFLFdBQVc7U0FDM0I7S0FDSjtDQUNKLENBQUEifQ==